import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import {
  buildSimilarVehiclesCrossShopPath,
  CoreResearchEntities,
  CoreResearchModel,
} from 'client/data/models/core-research';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { SliderCarousel } from 'site-modules/shared/components/slider-carousel/slider-carousel';

import { AlsoViewedVehicleCardCrossShop } from './also-viewed-vehicle-card-cross-shop';
import './also-viewed-vehicles-cross-shop.scss';

export function AlsoViewedVehiclesCrossShopUI({
  similarVehicles = null,
  lazyLoadImages = false,
  hasSeparator = true,
  isUsed = false,
}) {
  if (!similarVehicles || !similarVehicles.length) {
    return null;
  }

  return (
    <div className="also-viewed-vehicle-cross-shop" data-tracking-parent="edm-entry-also-viewed-vehicles">
      <h2 className="heading-3 mb-1_5">People who viewed this also viewed</h2>
      <SliderCarousel className="overflow-hidden-focusable row flex-nowrap px-0">
        {similarVehicles.map((vehicle, index) => {
          const key = `also-viewed-vehicle-${index}`;
          return (
            <Col xs={12} md={4} key={key}>
              <AlsoViewedVehicleCardCrossShop vehicle={vehicle} lazyLoadImage={lazyLoadImages} isUsed={isUsed} />
            </Col>
          );
        })}
      </SliderCarousel>
      {hasSeparator && <hr className="mt-1_5 mb-2" />}
    </div>
  );
}

AlsoViewedVehiclesCrossShopUI.propTypes = {
  similarVehicles: PropTypes.arrayOf(CoreResearchEntities.SimilarVehicleCrossShop),
  lazyLoadImages: PropTypes.bool,
  hasSeparator: PropTypes.bool,
  isUsed: PropTypes.bool,
};

export const AlsoViewedVehiclesCrossShop = connectToModel(AlsoViewedVehiclesCrossShopUI, {
  similarVehicles: bindToPath(
    ({ modelLinkCode }) => buildSimilarVehiclesCrossShopPath(modelLinkCode),
    CoreResearchModel
  ),
});

AlsoViewedVehiclesCrossShop.propTypes = {
  modelLinkCode: PropTypes.string.isRequired,
  isUsed: PropTypes.bool,
};
